import type { List } from '@gdladder/shared/entities';
import APIClient from '../../../api/APIClient';
import User from '../../../api/types/User';

export interface GetListResponse extends Pick<List, 'ID' | 'Length' | 'Name' | 'Description' | 'OwnerID'> {
    Owner: Pick<User, 'ID' | 'Name'>;
    progress: number;
}

export async function getList(listID: number) {
    const res = await APIClient.get<GetListResponse>(`/list/${listID}`);
    return res.data;
}
